<template lang="pug">

  .component-plan-controller
    .row
      .columns
        router-view(:item="item")
</template>
<script type="text/babel">
  import RouterTabHeaders from "components/structure/foundation/RouterTabHeaders";

  export default {
    name: "PlanController",
    components: {RouterTabHeaders},
    data() {
      return {

        tabs: [
          {
            headerName: 'Setup',
            name: 'plan',
            pathName: 'setup'
          },
          {
            headerName: 'Plan reservation rates',
            name: 'plan-reservation-rates',
            pathName: 'plan-reservation-rates'
          },

        ]
      }
    },
    created() {
    },
    methods: {},
    computed: {},
    props: ['item'],

  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Plan.vue?12c10ba3